import type * as Types from '../../../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCreateCustomVestingMutationVariables = Types.Exact<{
  vestingOccasion: Types.GqlWppVestingOccasionCreateInput;
}>;


export type GqlCreateCustomVestingMutation = { wppAddCustomVestingOccasion: { id: string } };

export type GqlUpdateCustomVestingMutationVariables = Types.Exact<{
  vestingOccasion: Types.GqlWppVestingOccasionUpdateInput;
}>;


export type GqlUpdateCustomVestingMutation = { wppUpdateCustomVestingOccasion: { id: string } };

export type GqlDeleteCustomVestingMutationVariables = Types.Exact<{
  vestingOccasionId: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteCustomVestingMutation = { wppDeleteCustomVestingOccasion: { id: string } };


export const CreateCustomVestingDocument = gql`
    mutation CreateCustomVesting($vestingOccasion: WppVestingOccasionCreateInput!) {
  wppAddCustomVestingOccasion(vestingOccasion: $vestingOccasion) {
    id
  }
}
    `;
export type GqlCreateCustomVestingMutationFn = Apollo.MutationFunction<GqlCreateCustomVestingMutation, GqlCreateCustomVestingMutationVariables>;

/**
 * __useCreateCustomVestingMutation__
 *
 * To run a mutation, you first call `useCreateCustomVestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomVestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomVestingMutation, { data, loading, error }] = useCreateCustomVestingMutation({
 *   variables: {
 *      vestingOccasion: // value for 'vestingOccasion'
 *   },
 * });
 */
export function useCreateCustomVestingMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateCustomVestingMutation, GqlCreateCustomVestingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateCustomVestingMutation, GqlCreateCustomVestingMutationVariables>(CreateCustomVestingDocument, options);
      }
export type CreateCustomVestingMutationHookResult = ReturnType<typeof useCreateCustomVestingMutation>;
export type CreateCustomVestingMutationResult = Apollo.MutationResult<GqlCreateCustomVestingMutation>;
export type CreateCustomVestingMutationOptions = Apollo.BaseMutationOptions<GqlCreateCustomVestingMutation, GqlCreateCustomVestingMutationVariables>;
export const UpdateCustomVestingDocument = gql`
    mutation UpdateCustomVesting($vestingOccasion: WppVestingOccasionUpdateInput!) {
  wppUpdateCustomVestingOccasion(vestingOccasion: $vestingOccasion) {
    id
  }
}
    `;
export type GqlUpdateCustomVestingMutationFn = Apollo.MutationFunction<GqlUpdateCustomVestingMutation, GqlUpdateCustomVestingMutationVariables>;

/**
 * __useUpdateCustomVestingMutation__
 *
 * To run a mutation, you first call `useUpdateCustomVestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomVestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomVestingMutation, { data, loading, error }] = useUpdateCustomVestingMutation({
 *   variables: {
 *      vestingOccasion: // value for 'vestingOccasion'
 *   },
 * });
 */
export function useUpdateCustomVestingMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateCustomVestingMutation, GqlUpdateCustomVestingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateCustomVestingMutation, GqlUpdateCustomVestingMutationVariables>(UpdateCustomVestingDocument, options);
      }
export type UpdateCustomVestingMutationHookResult = ReturnType<typeof useUpdateCustomVestingMutation>;
export type UpdateCustomVestingMutationResult = Apollo.MutationResult<GqlUpdateCustomVestingMutation>;
export type UpdateCustomVestingMutationOptions = Apollo.BaseMutationOptions<GqlUpdateCustomVestingMutation, GqlUpdateCustomVestingMutationVariables>;
export const DeleteCustomVestingDocument = gql`
    mutation DeleteCustomVesting($vestingOccasionId: ID!) {
  wppDeleteCustomVestingOccasion(vestingOccasionId: $vestingOccasionId) {
    id
  }
}
    `;
export type GqlDeleteCustomVestingMutationFn = Apollo.MutationFunction<GqlDeleteCustomVestingMutation, GqlDeleteCustomVestingMutationVariables>;

/**
 * __useDeleteCustomVestingMutation__
 *
 * To run a mutation, you first call `useDeleteCustomVestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomVestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomVestingMutation, { data, loading, error }] = useDeleteCustomVestingMutation({
 *   variables: {
 *      vestingOccasionId: // value for 'vestingOccasionId'
 *   },
 * });
 */
export function useDeleteCustomVestingMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteCustomVestingMutation, GqlDeleteCustomVestingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteCustomVestingMutation, GqlDeleteCustomVestingMutationVariables>(DeleteCustomVestingDocument, options);
      }
export type DeleteCustomVestingMutationHookResult = ReturnType<typeof useDeleteCustomVestingMutation>;
export type DeleteCustomVestingMutationResult = Apollo.MutationResult<GqlDeleteCustomVestingMutation>;
export type DeleteCustomVestingMutationOptions = Apollo.BaseMutationOptions<GqlDeleteCustomVestingMutation, GqlDeleteCustomVestingMutationVariables>;